import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/auth-context';

const ProtectedAdminRoute = ({ children }) => {
  const { user, initialized } = useAuth();

  if (!initialized) {
    return null;
  }

  if (!user) {
    return <Navigate to="/lkart/admin" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;